import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FaEye, FaEyeSlash } from 'react-icons/fa'


const SignInSchema = Yup.object().shape( {
    email: Yup.string().required("This field is required!").email("This is not valid email"),
    password: Yup.string().required("This field is required").min(6, "Minimum length is 6")
} )

export default function LoginForm() {

    let [isHidden, setIsHidden] = useState(true);

    const handleSubmit = (values: any) => {

    }

    return (
        <Formik
            initialValues={{email: '', password: ''}}
            onSubmit={handleSubmit}
            validationSchema={SignInSchema}
            >
            { (props: any) => {
                return (
                <Form className="formular__panel">
                    <div className="form__item p-0">
                        <Field className="form__item form--input" name="email" autoComplete="off" placeholder="email" type="text"/>
                        <ErrorMessage name="email"/>
                    </div>
                    <div className="form__item password__container">
                        <Field className="form--input item--password" name="password" placeholder="password" type={ isHidden ? "password" : "text"}/>
                        { isHidden ? <FaEye className="eye__button" onClick={() => { setIsHidden(!isHidden) }}/> : <FaEyeSlash className="eye__button" onClick={() => { setIsHidden(!isHidden) }}/>}
                        <ErrorMessage name="password"/>
                    </div>
                    <button className="form__item form--button">Login</button>
                    <button className="form__item form--button" onClick={()=>{localStorage.setItem("Token", "Jest");window.location.reload()}}>Login for developer</button>
                    <p className="form__item form--text"> Don't have an account?</p>
                </Form>
                )
            }}
        </Formik>
    )
}

